import script from "./CrudAreasTrabajo.vue?vue&type=script&setup=true&lang=js"
export * from "./CrudAreasTrabajo.vue?vue&type=script&setup=true&lang=js"

import "./CrudAreasTrabajo.vue?vue&type=style&index=0&id=bf538090&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bf538090"]])

export default __exports__